@if (label) {
  <span>{{ label | translate }}&nbsp;</span>
  }<span>{{ value | date: 'short' : '' : locale }}</span>
